import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'

import { NAV_LINKS } from '~/constants'

import { useUser } from '~/lib/auth'
import { setTokens } from '~/lib/auth-tokens'

export function SSO() {
  const [params, _setSearchParams] = useSearchParams()
  const [hasRefetched, setHasRefetched] = useState(false)
  const navigate = useNavigate()

  const accessToken = params.get('access_token')
  const refreshToken = params.get('refresh_token')

  const user = useUser()

  useEffect(() => {
    if (accessToken && refreshToken) {
      setTokens(accessToken, refreshToken)
      if (!hasRefetched) {
        user.refetch()
        setHasRefetched(true)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [accessToken, refreshToken, user])

  useEffect(() => {
    if (user.data) {
      navigate(NAV_LINKS.HOME.to)
    } else if (hasRefetched && !user.data) {
      navigate(NAV_LINKS.SIGNIN.to)
    }
  }, [hasRefetched, navigate, user])
  return <></>
}
